import React from "react";
import GameModal from "../../../Components/Game/Stat/Modal";
import storage from "../../../../Storage";
import Engine from "../Engine";
import {__, crashColor, isMobile} from "../../../../Helper";

class HistoryList extends React.Component {
    constructor (props){
        super(props);
        this.state = {
            games: [],
            name: storage.getKey('name'),
            token: storage.getKey('token'),
            game: this.props.game,
            gameRow: [],
            engine: Engine
        };
    }

    componentDidMount() {
        let { engine } = this.state;
        engine.trigger.on("busted_crash", data => this.busted(data));
        engine.trigger.on("game_status", data => this.gameSync(data));
    }

    busted(data){ //the single game
        //console.log("[Temp] busted: ", data, " | len: ", this.state.gameRow.length);
        //this.state.gameRow = __.reverse(this.state.gameRow);

        let busted  = (data.amount/100).toFixed(2);
        let color = crashColor(busted);
        
        if(isMobile()){
            if(this.state.gameRow.length === 10){
                this.state.gameRow.shift();
            }
        } else {
            if(this.state.gameRow.length === 10){
                this.state.gameRow.shift();
            }
        }

        let add = this.state.gameRow.concat([
            <li key={data.game_id}>
                <GameModal color={color} title={busted + 'x'} game_id={data.game_id} font={11} />
            </li>
        ]);

        this.setState({ gameRow: add });
    }

    gameSync(list){ //all from db
        if(list.crashes === undefined) return;
        if(list.crashes.length === 0) return;

       __.reverse(list.crashes).forEach((array, i) => {
        //list.crashes.forEach((array, i) => {
            if(i < 10){
                let busted  = (array.amount/100).toFixed(2);
                let color = crashColor(busted);
                let row = <li key={i}>
                    <GameModal key={i} color={color} title={busted + 'x'} game_id={array.game_id} font={11} />
                </li>;
                this.setState(state => ({ gameRow: [row, ...state.gameRow] }));
            }
        });
    }

    render () {
        if(isMobile()){
            if(this.state.gameRow.length >= 10)
                this.state.gameRow.length = 10;
        } else {
            if(this.state.gameRow.length >= 10)
                this.state.gameRow.length = 10;
        }
        return(
            <div className="pt-1 pb-2 history-list-crash">
                <ul>
                    {this.state.gameRow}
                </ul>
            </div>

        );
    }
}

export default HistoryList;